import React, { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ErrorBoundary } from "react-error-boundary";

import main_routes from './routes';
import { AuthContext } from './contexts/auth';
import { FeedbackContext } from './contexts/feedback';

import './index.css';

// AGENTS
import rossato_routes from 'agents/rossato-orari/index.js';
import eurogielle_routes from 'agents/eurogielle-ordini-produzione/index.js';
import rossato_orari_ocr_routes from 'agents/rossato-orari-ocr/routes/routes.js';
import lawyer_dataset_creator_routes from 'agents/lawyer-dataset-creator/routes/routes.js';
import tmb_registrazione_ddt_routes from 'agents/tmb-registrazione-ddt/index.js';
import pupa_registrazione_ddt_routes from 'agents/pupa-registrazione-ddt/index.js';
import mcm_registrazione_ddt_routes from 'agents/mcm-registrazione-ddt/index.js';
import mcm_rapportini_routes from 'agents/mcm-rapportini/index.js';
import esg_report_creator_routes from 'agents/esg-report-creator/index.js';
import cashflow_forecast_routes from 'agents/cashflow-forecast/index.js';
import blogger_routes from 'agents/blogger/index.js';
import aeo_analyst_routes from 'agents/aeo-analyst/index.js';

const routes = [
    ...main_routes,
    ...rossato_routes,
    ...eurogielle_routes,
    ...rossato_orari_ocr_routes,
    ...lawyer_dataset_creator_routes,
    ...tmb_registrazione_ddt_routes,
    ...pupa_registrazione_ddt_routes,
    ...mcm_registrazione_ddt_routes,
    ...mcm_rapportini_routes,
    ...esg_report_creator_routes,
    ...cashflow_forecast_routes,
    ...blogger_routes,
    ...aeo_analyst_routes,
];

const queryCache = new QueryClient({
    defaultConfig: {
        retry: 1
    },
    retry: 0
})

function fallbackRender({ error }) {
    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre style={{ color: "red" }}>{error.message}</pre>
        </div>
    );
}

function App() {

    return (
        <QueryClientProvider client={queryCache}>
            <Suspense>
                <ErrorBoundary fallbackRender={fallbackRender}>
                    <Router>
                        <AuthContext>
                            <FeedbackContext>
                                    <Routes>
                                        {routes?.map((layout, index) => {
                                            return (
                                                <Route key={index} element={<layout.layout />} >
                                                    {layout.routes.map((route, indexRoute) => {
                                                        return (
                                                            <Route
                                                                key={`${index}-${indexRoute}`}
                                                                {...route}
                                                                element={<route.element/>}
                                                            >
                                                                {route?.routes?.map((subroute, subIndex) =>
                                                                    <Route
                                                                        key={`${subIndex}-${index}-${indexRoute}`}
                                                                        {...subroute}
                                                                        element={<subroute.element/>}
                                                                    />
                                                                )}
                                                            </Route>
                                                        )
                                                    })}
                                                </Route>
                                            )
                                        })}
                                    </Routes>
                            </FeedbackContext>
                        </AuthContext>
                    </Router>
                </ErrorBoundary>
            </Suspense>

            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    )
}

export default App;
